import * as React from 'react';
import { ILinksData } from '../dobbies-account-menu.props.autogenerated';

export interface IDropDownProps {
    links: ILinksData[];
    url: string;
    heading: string;
}
export interface ILinkType {
    destinationUrl: string;
    linkText: string | undefined;
}
const DropDown: React.FC<IDropDownProps> = ({ links, url, heading }) => {
    const mappedLinks = _mapLinksToDropDown(links);
    const selectedLink = getSelectedLink(mappedLinks, url);
    const [showList, setShowList] = React.useState(false);
    const ToggleList = () => setShowList(!showList);
    return (
        <div className='ms-dobbies-account__cta account-menu'>
            <p role={selectedLink?.linkText} onClick={ToggleList}>
                {selectedLink ? selectedLink.linkText : heading}
            </p>
            <ul className={showList ? 'account-menu__list--show' : 'account-menu__list--hide'}>
                {/* VSI-Customization -- START Render each link inside with li tag  */}
                {mappedLinks.map((link: ILinkType) => (
                    <li
                        key={link.linkText}
                        className={
                            link.linkText === selectedLink?.linkText ? 'account-menu__list--item active' : 'account-menu__list--item'
                        }
                    >
                        <a href={link.destinationUrl}>{link.linkText}</a>
                    </li>
                ))}
                {/* VSI-Customization -- END  */}
            </ul>
        </div>
    );
};
/* VSI-Customization -- START Return the selected link based on URL  */
export const getSelectedLink = (links: ILinkType[], url: string) => {
    const splittedUrl = url && url.split('/');
    let selectedLink;
    if (splittedUrl?.length > 0) {
        for (const [_, link] of links.entries()) {
            const splittedLinkUrl = link.destinationUrl?.split('/');
            if (splittedLinkUrl[splittedLinkUrl.length - 1] === splittedUrl[splittedUrl?.length - 1]) {
                selectedLink = link;
            }
        }
        return selectedLink;
    }
    return;
};
/* VSI-Customization -- END  */

/* VSI-Customization -- START Map links coming from CMS into object with linktext and destinationURL  */
export const _mapLinksToDropDown = (links: ILinksData[]) => {
    const mappedLinks: ILinkType[] = [];

    links.forEach((link, index) => {
        const mappedLink = {
            destinationUrl: link.linkUrl.destinationUrl,
            linkText: link.linkText
        };
        mappedLinks.push(mappedLink);
    });
    return mappedLinks;
};
/* VSI-Customization -- END  */

export default DropDown;
